
import { Message, IMessage, MessageTextConverter } from "./Message";

export interface ITextMessage  extends IMessage {
   
    Text: string;
   
}

export const TextMessage = (props: ITextMessage ) => {

    return <Message {...props}>{ MessageTextConverter.parse(props.Text) }</Message>;

}
